import { message } from '@widesk-ui/hooks/useMessage';

export function loadCKFinder(): Promise<void> {
	return new Promise((resolve) => {
		if (window.CKFinder) {
			resolve();
			return;
		}

		const scriptId = 'ckfinder-script';

		let script = document.getElementById(scriptId) as HTMLScriptElement | null;

		if (!script) {
			script = document.createElement('script');
			script.id = scriptId;
			script.src = '/ckfinder/ckfinder.js';
			script.defer = true;
			document.body.appendChild(script);
		}

		script.onload = () => resolve();
	});
}

export type OpenCKFinderOptions = {
	disableOnSelectMessage?: boolean;
	onSelect?: (url: string, file: File) => void;
}

export default async function openCKFinder(options: OpenCKFinderOptions = {}) {
	await loadCKFinder();

	window.CKFinder.modal({
		connectorPath: `/website/ckfinder/connector`,
		chooseFiles: !!options.onSelect,
		width: 900,
		height: 600,
		onInit: (finder: any) => {
			if (options.onSelect) {
				finder.on('files:choose', async (evt: any) => {
					const file = evt.data.files.first();
					const url = file.getUrl();
					const filename = file.get('name') || 'file';
					const extension = file.get('extension') || '';
					const res = await fetch(url);
					const finalName = extension ? `${filename}.${extension}` : filename;

					const blob = await res.blob();
					const mime = blob.type || `image/${extension || 'jpeg'}`;
					const realFile = new File([blob], finalName, { type: mime, });

					options.onSelect?.(url, realFile);

					if (!options.disableOnSelectMessage) {
						message.success('Fichier sélectionné');
					}
				});

				finder.on('file:choose:resizedImage', async (evt: any) => {
					const resized = evt.data.resizedUrl;

					const res = await fetch(resized);
					const blob = await res.blob();

					// Essai de nom + extension depuis l’URL
					const match = resized.match(/([^/?#]+)(\?.*)?$/);
					const filename = match?.[1] ?? 'image-resized.jpg';

					// MIME automatique si présent, sinon fallback
					const mime = blob.type || 'image/jpeg';

					const file = new File([blob], filename, { type: mime });

					options.onSelect?.(resized, file);

					message.success('Image redimensionnée');
				});
			}
		},
	});
}